/* eslint-disable import/prefer-default-export */
import {
  useQuery,
} from '@tanstack/react-query';
import { getExhibitions } from '../../api/exhibitions';

function useExhibitions() {
  return useQuery({
    queryKey: ['exhibitions'],
    queryFn: () => getExhibitions(),
  });
}

export {
  useExhibitions,
};
